export default __webpack_public_path__ + "static/media/visuel.3e8f28f9.svg";